import { Box, TextField, Typography } from '@mui/material';
import { ChangeEvent, useState } from 'react';

interface Props {
  label: string;
  defaultValue: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  text?: string;
  touched?: boolean;
  errors?: string;
}

const NumberInput = ({
  label,
  defaultValue,
  onChange,
  min,
  max,
  text
}: Props): JSX.Element => {
  const [val, setVal] = useState<number>(defaultValue);
  const handleChange = ({
    target: { value }
  }: ChangeEvent<HTMLInputElement>): void => {
    const newValue = parseFloat(value);
    if (!isNaN(newValue) && newValue >= min && newValue <= max) {
      onChange(newValue);
      setVal(newValue);
    }
  };

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 500,
          color: '#44474E',
          marginTop: '15px'
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '30px'
        }}
      >
        <TextField
          sx={{
            width: {
              xs: '100%',
              sm: '100%'
            },
            height: '55px',
            marginTop: '15px'
          }}
          type="number"
          value={val}
          onChange={handleChange}
          InputProps={{
            inputProps: { min, max }
          }}
        />
        {text && (
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              color: '#1A1B1F',
              letterSpacing: '0.5px'
            }}
          >
            {text}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
export default NumberInput;
